const isNodeSelected = (state, nodeId) => {
  let selected = false;
  state.doc.nodesBetween(state.selection.from, state.selection.to, (node) => {
    if (node.attrs.id === nodeId) {
      selected = true;
    }
    return !selected;
  });
  return selected;
};
export {
  isNodeSelected
};
//# sourceMappingURL=is-node-selected.js.map
